import { createApp } from 'vue'
import Classifica from './index';
import i18n from '../../i18n';

import '../../styles/general.less';

import mitt from 'mitt';

const emitter = mitt();

const app = createApp(Classifica);
app.config.globalProperties.emitter = emitter;
app.use(i18n);
app.mount('#app');